<template>
  <v-container>
    <v-layout row v-if='myPatient==null' justify-center class='startbtn'>
      <v-btn color="primary" dark @click.native.stop='openselector'>Click here to select a Patient for Recomm Demo</v-btn>
    </v-layout>
    <v-layout row wrap v-else>
      <v-flex xs12 md3>
        <v-layout row wrap>
          <v-flex xs12 mt-2 mb-3 class="text-xs-center">
              <span class='title'>Patient Characteristics</span>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 md12 class='patientpanel' :style='panelStyle'>
            <v-expansion-panel expand>
              <v-expansion-panel-content
                v-for='(group,key) in myPatientDisplay' :key='key' v-if='(key!="derived")&&(myPatientDisplay[key].length!=0)'>
                <div slot='header'>
                  <span style="color:green;">{{displaylabel(key)}}</span>
                </div>
                <v-layout row wrap>
                  <v-flex  v-for='entry in myPatientDisplay[key]'
                    :key='entry.name'
                    :xs4='displaycol(key)==3'
                    :xs6='displaycol(key)==2'
                    :xs12='displaycol(key)==1'
                  >
                    <v-card flat tile v-if='entry.display'>
                      <v-card-title v-if='entry.type=="string"'>
                        <v-text-field
                          v-model="patientModel.patient.features[entry.name]"
                          :label="entry.label"
                          :box="inEditMode"
                        >
                        </v-text-field>
                      </v-card-title>
                      <v-card-title v-if='entry.type=="number"'>
                        <v-text-field
                          v-model.number="patientModel.patient.features[entry.name]"
                          type="number"
                          :label="entry.label"
                          :box="inEditMode"
                          :suffix="entry.unit"
                        >
                        </v-text-field>
                      </v-card-title>
                      <v-card-title v-if='entry.type=="enum"'>
                        <v-select
                          v-model="patientModel.patient.features[entry.name]"
                          :items="entry.items"
                          :label="entry.label"
                        ></v-select>
                      </v-card-title>
                      <v-card-title v-if='entry.type=="boolean"'>
                        <v-checkbox
                          :label="entry.label"
                          v-model="patientModel.patient.features[entry.name]"
                          hide-details
                          ></v-checkbox>
                      </v-card-title>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center>
          <v-flex xs6 >
              <v-btn @click='calculate' :disabled='inplay'>Calculate</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md9>
        <v-layout row wrap>
          <v-flex xs12 md12 >
            <v-tabs fixed-tabs>
              <v-tab v-for="i in 6" :key="i">{{tabtitle[i]}}</v-tab>
              <v-tabs-items >
                  <v-tab-item key="1">
                    <v-layout row wrap>
                      <v-flex xs12 md12 class='patientpanel' :style='panelStyle'>
                        <v-timeline dense clipped>
                          <v-timeline-item class="mb-1" large fill-dot>
                            <span slot="icon" style='color:#fff;' @click='toggleunit'>{{unit}}</span>
                            <span class='headline font-weight-light'>USPSTF Recommendations Ranked By Life Expectancy Gained</span>
                            <v-progress-linear v-model="comprogress"></v-progress-linear>
                          </v-timeline-item>
                          <v-slide-x-transition group>
                            <v-timeline-item
                              fill-dot
                              class="white--text mb-2"
                              :key='index'
                              :class='{active:item.gain<=0}'
                              :color='dotcolor(index)'
                              v-for='(item,index) in orderedrecs'
                            >
                              <span slot="icon" v-if='item.gain!=-1'>
                                <span v-show='item.desirable' >
                                  <span v-if='unityear'>{{item.gain |decimal2}}</span>
                                  <span v-else>
                                    <span v-if='(item.gain>0.08)'>{{item.gain*unitfactor |decimal0}}</span>
                                    <span v-else>{{lessthenonemonth}}</span>
                                  </span>
                                </span>
                              </span>
                              <span slot="icon" v-else>  <span class="mdi mdi-loading mdi-spin mdi-18px" v-if='patientready'></span></span>
                              <v-expansion-panel expand>
                                <v-expansion-panel-content>
                                  <div slot='header'>
                                    <reccard :rec='reclist[item.name]' />
                                  </div>
                                  <v-layout row wrap>
                                    <v-flex xs3 class='text-xs-center text-sm-center text-md-center text-lg-center'>
                                      <span class="subtitle">Baseline (yrs)</span><br>
                                      <span class='display-1'>{{outcome.lifeexpectancy.baseline | decimal3}}</span>
                                    </v-flex >
                                    <v-flex xs3 class='text-xs-center text-sm-center text-md-center text-lg-center'>
                                        <span class="subtitle">Total without intervention (yrs)</span><br>
                                        <span class='display-1' v-if='outcome.lifeexpectancy[item.name]'>{{outcome.lifeexpectancy[item.name].total.noscreening | decimal3}}</span>
                                        <span class='display-1' v-else >N/A</span>
                                    </v-flex >
                                    <v-flex xs3 class='text-xs-center text-sm-center text-md-center text-lg-center'>
                                      <span class="subtitle">Total with intervention (yrs)</span><br>
                                      <span class='display-1' v-if='outcome.lifeexpectancy[item.name]'>{{outcome.lifeexpectancy[item.name].total.screening | decimal3}}</span>
                                      <span class='display-1' v-else >N/A</span>
                                    </v-flex >
                                    <v-flex xs3 class='text-xs-center text-sm-center text-md-center text-lg-center'>
                                      <span class="subtitle">Desirable</span><br>
                                      <span class='display-1' v-if='item.desirable'>Yes</span>
                                      <span class='display-1' v-else >No</span>
                                    </v-flex >
                                  </v-layout>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-timeline-item>
                          </v-slide-x-transition>
                        </v-timeline>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-center>
                      <v-flex xs6>
                        <a ref="downloadAnchorElem" :href='datastr' :download='resultjson' style="display:none"></a>
                      </v-flex>
                      <v-flex xs6 >
                          <v-btn @click='savefile' :disabled='inplay'>Save Result</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-tab-item>
                  <v-tab-item key="2">
                    <v-layout row wrap justify-center>
                      <v-flex xs4 offset-xs7 >
                        <v-select
                          v-model='currentService'
                             :items="servicekeys"
                             label="Select a service"
                             v-if='servicekeys.length!=0'
                        ></v-select>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-center>
                      <v-flex xs12 class='patientpanel' :style='tableStyle'>
                        <v-data-table
                          :headers="mortality_headers"
                          :items="mortalityresults"
                          :pagination.sync = "pagination"
                          class="elevation-1"
                          v-if='mortalityresults.length>0'
                          hide-actions
                        >
                          <template slot='items' slot-scope="props">
                            <td>{{ props.item.age }}</td>
                            <td class="text-xs-center">{{ props.item.q_x }}</td>
                            <td class="text-xs-center">{{ props.item.q_p_x }}</td>
                            <td class="text-xs-center">{{ props.item.q_ps_x }}</td>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-tab-item>
                  <v-tab-item key="3">
                    <v-layout row wrap justify-center>
                      <v-flex xs12 class='patientpanel' :style='tableStyle'>
                        <v-data-table
                          :headers="rrisk_headers"
                          :items="rriskresults"
                          :pagination.sync = "pagination"
                          class="elevation-1"
                          v-if='rriskresults.length>0'
                          hide-actions
                        >
                          <template slot='items' slot-scope="props">
                            <td>{{ props.item.age }}</td>
                            <td class="text-xs-center">{{ props.item.tobacco }}</td>
                            <td class="text-xs-center">{{ props.item.obesity }}</td>
                            <td class="text-xs-center">{{ props.item.alcoholism }}</td>
                            <td class="text-xs-center">{{ props.item.total}}</td>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-tab-item>
                  <v-tab-item
                    key="4"
                  >
                  <v-layout row wrap justify-center>
                    <v-flex xs12 class='patientpanel' :style='tableStyle'>
                      <v-data-table
                        :headers="arisk_headers"
                        :items="ariskresults"
                        :pagination.sync = "pagination"
                        class="elevation-1"
                        v-if='ariskresults.length>0'
                        hide-actions
                      >
                        <template slot='items' slot-scope="props">
                          <td>{{ props.item.age }}</td>
                          <td class="text-xs-center">{{ props.item.cholesterol }}</td>
                          <td class="text-xs-center">{{ props.item.hypertension }}</td>
                          <td class="text-xs-center">{{ props.item.diabetes }}</td>
                          <td class="text-xs-center">{{ props.item.aspirin }}</td>
                          <td class="text-xs-center">{{ props.item.osteoporosis }}</td>
                          <td class="text-xs-center">{{ props.item.depression }}</td>
                          <td class="text-xs-center">{{ props.item.lungcancer }}</td>
                          <td class="text-xs-center">{{ props.item.total}}</td>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-tab-item>
                <v-tab-item key="5">
                  <v-layout row wrap justify-center>
                    <v-flex xs12 class='patientpanel' :style='tableStyle'>
                      <v-data-table
                        :headers="derived_headers"
                        :items="derivedresults"
                        :pagination.sync = "pagination"
                        class="elevation-1"
                        v-if='derivedresults.length>0'
                              hide-actions
                      >
                        <template slot='items' slot-scope="props">
                          <td>{{ props.item.age }}</td>
                          <td class="text-xs-center">{{ props.item.mirisk }}</td>
                          <td class="text-xs-center">{{ props.item.stroke10y }}</td>
                          <td class="text-xs-center">{{ props.item.blgirisk }}</td>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>

                </v-tab-item>
                  <v-tab-item
                    key="6"
                  >
                  <v-layout row wrap justify-center>
                    <v-flex xs4 offset-xs7 >
                      <v-select
                        v-model='currentService'
                           :items="servicekeys"
                           label="Select a service"
                           v-if='servicekeys.length!=0'
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 class='patientpanel' :style='tableStyle'>
                      <v-data-table
                        :headers="inter_headers"
                        :items="intermediateresults"
                        :pagination.sync = "pagination"
                        class="elevation-1"
                        v-if='intermediateresults.length>0'
                        hide-actions
                      >
                        <template slot='items' slot-scope="props">
                          <td>{{ props.item.age }}</td>
                          <td class="text-xs-center">{{ props.item.screeningbenefit }}</td>
                          <td class="text-xs-center">{{ props.item.screeningrisk }}</td>
                          <td class="text-xs-center">{{ props.item.netbenefit }}</td>
                          <td class="text-xs-center">{{ props.item.q_ps_x }}</td>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-snackbar v-model="snackbar" >
      Error! Please view app log to see more details.
      <v-btn  dark flat   @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>

import reccard from '../components/reccard.vue'
    export default {
    data: () => ({
      events: [],
      input: null,
      nonce: 0,
      reclistko:{"naan":'ipp',"name":'recommendationtable',"ver":'v0.0.2','endpoint':'recommendationlist'},
      executiveko:{"naan":'ipp',"name":'executive',"apiversion":'1.0','endpoint':'process'},
      featuresampleko:{"naan":'ipp',"name":'bgariskcrca',"ver":'v0.0.2','endpoint':'/extractedFeatures'},
      reclistready: false,
      lifegainendpoint:'lifeexpectancygained',
      eventlog: [],
      valid: true,
      patientModel: {},
      patientready:true,
      reccomputed:0,
      checkbox: false,
      dialog: false,
      patientIndex:-1,
      windowHeight:0,
      inEditMode:false,
      models:[
        {"name":"bmi","id":"int001","label":"Body Mass Index", "value":28,"unit":"lb/inch^2"},
        {"name":"packyears","id":"int002","label":"Smoke Pack-Years", "value":28,"unit":"pack-years"}
      ],
      currentModelIndex:0,
      rankedrecs:[],
      animatedlist:[],
      reclist:{},
      outcome:{},
      unityear:true,
      lessthenonemonth:'<1',
      tabtitle:['0','Prioritized Services', 'Mortality Rates','All-Cause Risks','Disease-Specific Risks', 'Derived Features','Intermediate Results'],
      mortality_headers: [
         {
           text: 'Age',
           align: 'left',
           sortable: true,
           value: 'age'
         },
         { text: 'National Average (q_x)', align: 'center',value: 'q_x' },
         { text: 'Risk Adjusted (q_p_x)', align: 'center',value: 'q_p_x' },
         { text: 'Service (q_ps_x)', align: 'center',value: 'q_ps_x' }
       ],
      inter_headers: [
         {
           text: 'Age',
           align: 'left',
           sortable: true,
           value: 'age'
         },
         { text: 'Screening Benefit', align: 'center',value: 'screeningbenefit' },
         { text: 'Screening Risk', align: 'center',value: 'screeningrisk' },
         { text: 'Net Adjustment', align: 'center',value: 'netbenefit' },
         { text: 'Mortality Rate (q_ps_x)', align: 'center',value: 'q_ps_x' }
       ],
       arisk_headers: [
          {
            text: 'Age',
            align: 'left',
            sortable: true,
            value: 'age'
          },
          { text: 'cholesterol', align: 'center',value: 'cholesterol' },
          { text: 'Hypertension', align: 'center',value: 'hypertension' },
          { text: 'Diabetes', align: 'center',value: 'diabetes' },
          { text: 'Aspirin', align: 'center',value: 'aspirin' },
          { text: 'Osteoporosis', align: 'center',value: 'osteoporosis' },
          { text: 'Depression', align: 'center',value: 'depression' },
          { text: 'Lung Cancer', align: 'center',value: 'lungcancer' },
          { text: 'Total', align: 'center',value: 'total' }
        ],
       rrisk_headers: [
          {
            text: 'Age',
            align: 'left',
            sortable: true,
            value: 'age'
          },
          { text: 'Tobacco', align: 'center',value: 'tobacco' },
          { text: 'Obesity', align: 'center',value: 'obesity' },
          { text: 'Alcoholism', align: 'center',value: 'alcoholism' },
          { text: 'Total', align: 'center',value: 'total' }
        ],
       derived_headers: [
          {
            text: 'Age',
            align: 'left',
            sortable: true,
            value: 'age'
          },
          { text: 'MI Risk',align: 'center', value: 'mirisk' },
          { text: 'Stroke10Y', align: 'center', value: 'stroke10y' },
          { text: 'Baseline GI Risk', align: 'center',value: 'blgirisk' }
        ],
       pagination: {
           rowsPerPage: -1
       },
       currentService:"",
       hasError:false,
       snackbar: false,
       inplay:false
    }),
    created: function(){
      this.$bus.$on('selectPatient', this.selectPatient )
    },
    mounted: function() {
      var self=this
      this.windowHeight = window.innerHeight
      window.addEventListener('resize', () => {
          self.windowHeight = window.innerHeight
        });
      this.patientIndex=this.$store.getters.getCurrentPatientIndex
      this.patientModel= JSON.parse(JSON.stringify(this.currentPatientData))
    },
    components:{
      reccard
    },
    watch:{
      myPatient: function(){
        if(this.myPatient!=null){
          this.patientModel= JSON.parse(JSON.stringify(this.currentPatientData))
        }
      }
    },
    filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      },
      decimal2: function(value) {
        if(!value) return ''
        return value.toFixed(2)
      },
      decimal3: function(value) {
        if(!value) return ''
        return value.toFixed(3)
      },
      decimal0: function(value) {
        if(!value) return ''
        return value.toFixed(0)
      }
    },
    computed: {
      servicekeys: function(){
        var arr = []
        if(Object.keys(this.reclist).length>0){
          for (var key in this.reclist) {
            arr.push(key)
          }
        }
        return arr
      },
      ariskresults:  function() {
        var arr = []
        if(this.outcome.bgrelrisk){
            var cholesterolarr = this.outcome.bgabsrisk.cholesterol.split(',')
            var hypertensionarr = this.outcome.bgabsrisk.hypertension.split(',')
            var diabetesarr = this.outcome.bgabsrisk.diabetes.split(',')
            var aspirinarr = this.outcome.bgabsrisk.aspirin.split(',')
            var osteoporosisarr = this.outcome.bgabsrisk.osteoporosis.split(',')
            var depressionarr = this.outcome.bgabsrisk.depression.split(',')
            var lungcancerarr = this.outcome.bgabsrisk.lungca.split(',')
            for(var i=0;i<101;i++){
              var obj = {"age":0,"q_x":0,"q_p_x":0}
              obj.age= i
              obj.cholesterol= cholesterolarr[i]
              obj.hypertension = hypertensionarr[i]
              obj.diabetes=diabetesarr[i]
              obj.aspirin = aspirinarr[i]
              obj.osteoporosis =osteoporosisarr[i]
              obj.depression =depressionarr[i]
              obj.lungcancer = lungcancerarr[i]
              obj.total = parseFloat(cholesterolarr[i])+parseFloat(hypertensionarr[i])+parseFloat(diabetesarr[i])+parseFloat(aspirinarr[i])+parseFloat(osteoporosisarr[i])+parseFloat(depressionarr[i])
              // +parseFloat(lungcancerarr[i])
              arr.push(obj)
            }
        }
        return arr
      },
      rriskresults:  function() {
        var arr = []
        if(this.outcome.bgrelrisk){
            var tob = this.outcome.bgrelrisk.tobacco.split(',')
            var obe = this.outcome.bgrelrisk.obesity.split(',')
            var a1c = this.outcome.bgrelrisk.alcoholism.split(',')
            for(var i=0;i<101;i++){
              var obj = {"age":0,"q_x":0,"q_p_x":0}
              obj.age= i
              obj.tobacco= tob[i]
              obj.obesity = obe[i]
              obj.alcoholism=a1c[i]
              obj.total = tob[i]*obe[i]*a1c[i]
              arr.push(obj)
            }
        }
        return arr
      },
      mortalityresults: function() {
        var arr = []
        if(this.outcome.mortalityrate){
            var qx = this.outcome.mortalityrate.baseline.value.split(',')
            var qpx = this.outcome.mortalityrate.riskadjusted.value.split(',')
            var qpsx = []
            if(this.outcome.mortalityrate[this.currentService]){
              qpsx=this.outcome.mortalityrate[this.currentService].value.split(',')
            }
            for(var i=0;i<101;i++){
              var obj = {"age":0,"q_x":0,"q_p_x":0}
              obj.age= i
              obj.q_x = qx[i]
              obj.q_p_x = qpx[i]
              obj.q_ps_x=0
              if(this.outcome.mortalityrate[this.currentService]){
                obj.q_ps_x = qpsx[i]
              }
              arr.push(obj)
            }

        }
        return arr
      },
      intermediateresults: function() {
        var arr = []
        if(this.outcome.netbenefit){
          if(this.outcome.netbenefit[this.currentService]){
            var benefitarr = this.outcome.netbenefit[this.currentService].benefit.split(',')
            var riskarr = this.outcome.netbenefit[this.currentService].risk.split(',')
            var qpsx = []
            if(this.outcome.mortalityrate[this.currentService]){
              qpsx=this.outcome.mortalityrate[this.currentService].value.split(',')
            }
            for(var i=0;i<101;i++){
              var obj = {}
              obj.age= i
              obj.screeningbenefit = benefitarr[i]
              obj.screeningrisk = riskarr[i]
              obj.netbenefit = riskarr[i]-benefitarr[i]
              obj.q_ps_x=0
              if(this.outcome.mortalityrate[this.currentService]){
                obj.q_ps_x = qpsx[i]
              }
              arr.push(obj)
            }
          }
        }
        return arr
      },
      derivedresults: function() {
        var arr = []
        if(this.outcome.netbenefit){
          var miriskarr = this.outcome.features.mirisk.split(',')
          var strokearr = this.outcome.features.stroke10y.split(',')
          var baselinegiriskarr = this.outcome.features.baselineGIRisk.split(',')
          for(var i=0;i<101;i++){
            var obj = {"age":0,"mirisk":0,"stroke10y":0,"blgirisk":0}
            obj.age= i
            obj.mirisk=miriskarr[i]
            obj.stroke10y=strokearr[i]
            obj.blgirisk=baselinegiriskarr[i]
            arr.push(obj)
          }
        }
        return arr
      },
      orderedrecs: function(){
        return this.animatedlist.sort(function(a,b){
          if(!a.desirable|a.desirable==0){
            return 1
          }else {
            if(!b.desirable|b.desirable==0){
              return -1
            }else {
              return b.gain-a.gain
            }
          }

        })
      },
      comprogress: function(){
        if(this.rankedrecs.length==0){
          return 0
        } else {
          return this.reccomputed*100/this.rankedrecs.length
        }
      },
      currentPatientData () {
        return this.$store.getters.getcurrentPatientData
      },
      panelheight: function(){
        return this.windowHeight - 250
      },
      tableheight: function(){
        return this.windowHeight - 285
      },
      panelStyle () {
        return {
          height: `${this.panelheight}px`,
        }
      },
      tableStyle () {
        return {
          height: `${this.tableheight}px`,
        }
      },
      timeline () {
        return this.events.slice().reverse()
      },
      activator_url: function(){
        var url = this.$store.getters.getcurrentactivatorurl
        if(url.endsWith('/')){
          return url
        }else {
          return url+'/'
        }
      },
      library_url: function(){
        return 'http://localhost:8081/'
        // return this.$store.getters.getlibraryurl
      },
      objlink:function(){
        return this.library_url+'/#/object/'+this.reclistko.naan+'%2F'+this.reclistko.name+'%2F'+this.reclistko.ver
      },
      myPatient: function(){
        if(this.patientIndex!=-1){
          return this.$store.getters.getPatientPanel(this.patientIndex)
        } else {
          return null
        }
      },
      myPatientDisplay: function(){
        var groupPanel = {}
        var female = (this.patientModel.patient.features.gender.toLowerCase() == 'female')
        if(this.myPatient!=null){
          this.myPatient.patient.features.forEach(function(e){
            var displayable=true
            if(groupPanel[e.group]==null){
              groupPanel[e.group]=[]
            }
            if(e.flag){
              if(e.flag=='female'){
                displayable=displayable&&female
              }
            }
            e.display=displayable
            if(displayable){
              groupPanel[e.group].push(e)
            }
          })
        }
        return groupPanel
      },
      groupSchema:function(){
          return this.$store.getters.getGroupDisplaySchema
      },
      unit:function(){
        if(this.unityear){
          return 'Years'
        } else {
          return 'Months'
        }
      },
      unitfactor:function(){
        if(this.unityear){
          return 1
        } else {
          return 12
        }
      },
      datastr: function(){
        return "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.rankedrecs))
      },
      resultjson:function(){
        return this.patientModel.patient.id.replace('ipp-patient-','')+'.json'
      }
    },
    methods: {
      toggleunit:function(){
        this.unityear=!this.unityear
      },
      dotcolor:function(index){
        var c='#9e9e9e'
        if((this.rankedrecs[index].gain>=0)&&(index<3)){
          c='#2196F3'
        }
        return c
      },
      selectPatient:function(index){
        console.log(index)
        this.patientIndex=index
        this.reclistready =false
        this.rankedrecs=[]
        this.animatedlist=[]
        this.reccomputed=0
      },
      openselector: function(){
        this.$bus.$emit('openselector',true)
      },
      displaylabel:function(key){
        if(this.myPatient!=null){
          var inx = this.groupSchema.findIndex(function(e,index){
            return e.groupname==key
          })

          if (inx!=-1){
            return this.groupSchema[inx]['label']
          } else {
            return key
          }
        }
      },
      displaycol:function(key){
        if(this.myPatient!=null){
          var inx = this.groupSchema.findIndex(function(e,index){
            return e.groupname==key
          })
          if (inx!=-1){
            return this.groupSchema[inx]['col']
          } else {
            return 1
          }
        }
      },
      KOPostaxios:function(instr){
        var self = this
        var config = {
          method:'post',
          url:this.activator_url+ instr.arkID + instr.endpoint,
          "headers": {
            "content-type": "application/json",
          },
          "data": instr.data
        }
        self.appendLog(instr.key, "K-GRID Service Request - Sending Patient Data to Knowledge Object: " + instr.arkID);
        return this.$http(config)
          .then(function(response){
            instr.success(response.data)
            self.hasError = false;
            self.appendLog(instr.key, "K-GRID Service Response - Response results returned from Knowledge Object: " + instr.arkID);
          })
          .catch(function(error){
            // self.appendLog(instr.key, "K-GRID Service Response - Error Message: " + error.response.status);
            console.error(error)
            self.hasError = true;
            self.snackbar =true;
            if(error.response.status==404){
              self.error404=true;
            }
            if (error.response) {
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            }
            instr.error(error.response.data);
            // self.appendLog('err', "K-GRID Service Response - Error returned from Knowledge Object: " + instr.arkID);
          })
      },
      appendLog: function (key, s) {
        var ts = this.$moment().format('ddd, MMM Do YYYY, h:mm:ss A Z')
        var text = ts+" "+s
        this.$bus.$emit('newentry', text)
      },
      recalc () {
        var self = this
        this.models.forEach(function(e){
          switch(e.name){
            case "bmi":
              var w= self.patientModel.patient.features.weight | 0
              var h = self.patientModel.patient.features.height |1
              e.value = w/h/h*703
              break;
            case "packyears":
              var age = self.patientModel.patient.features.age | 0
              var agebegan = self.patientModel.patient.features.smoking_agebegan | 0
              var packsday = self.patientModel.patient.features.smoking_packsday | 0
              e.value = (age - agebegan)*packsday
              console.log(age+"  " +agebegan+"  "+packsday+" => "+e.value)
              break;
          }
        })
      },
      calculate: function() {
        var self =this
        self.rankedrecs=[]
        self.animatedlist=[]
        self.reccomputed =0
        var inputData = JSON.parse(JSON.stringify(this.myPatient))
        inputData.patient.features.forEach(function(e,index,arr){
          arr[index].value=self.patientModel.patient.features[e.name]
        })
        if(this.patientModel!=null){
          var obj ={}
          obj.arkID = this.executiveko.naan+'/'+this.executiveko.name
          obj.endpoint = '/'+this.executiveko.apiversion+'/'+this.executiveko.endpoint
          obj.data= JSON.stringify(inputData)
          obj.key='App'
          obj.success= function(response) {
            console.log(response)
            // console.log("Ref: "+JSON.stringify(response.result.mortalityrate))
            console.log('LE: '+JSON.stringify(response.result.lifeexpectancy))
            self.outcome = response.result
            self.reclist = response.result.reclist
            for(var key in self.reclist){
              // var obj={}
              // obj.name=key
              // obj.gain=-1
              // obj.desirable=false
              // obj.ready=false
              // self.animatedlist.push(obj)
            }

            for (var key in response.result.rankedreclist){
                self.rankedrecs.push(response.result.rankedreclist[key])
                self.animatedlist.push(response.result.rankedreclist[key])
            }
            // var i = 0;
            // self.animatedlist.forEach(function(ale,index){
            //   let k1=self.rankedrecs.findIndex(function(e){
            //     return ale.name===e.name
            //   })
            //   console.log(index+"  -   "+ale)
            //   setTimeout(function(){
            //     ale.gain=response.result.rankedreclist[k1].gain
            //     ale.desirable=response.result.rankedreclist[k1].desirable
            //     ale.ready=true
            //     self.reccomputed=index
            //     if(index>=self.rankedrecs.length) {
            //           self.inplay=false
            //         }
            //   },200)
            // })
          }
          obj.error=function(resp){
            console.error(resp)
          }
          this.inplay = false
          this.KOPostaxios(obj)
        }
      },
      savefile: function(){
        this.$refs.downloadAnchorElem.click();
      }
    }
  };
</script>
<style scoped>
.container {
  max-width: 100%;
}
.v-timeline {
  max-width: 86%;
  margin:0 auto;
  padding-top: 24px;
}
.patientpanel {
  background-color: #efefef;
  overflow-y:scroll;
}
.ipppanel{
  overflow-y:auto;
}
.featurelabel {
  font-size: 0.85rem;
  padding: 0 0.2rem ;
  bottom: 0;
  position: relative;
}
.featurevalue {
  font-size: 1.55rem;
  padding: 0 0.2rem 0 0.4rem;;
}
.v-card__title {
  padding: 6px 16px;
}
.v-list {
  padding: 4px 0;
}
.startbtn {
  position: absolute;
  bottom: 380px;
  width: 100%;
}
.v-input--selection-controls {
    margin-top: 0px;
    padding-top: 1px;
}
.v-input--selection-controls .v-input__slot {
    margin-bottom: 0px;
}
</style>
